export const ErrNotFound = 'key not found';
//# sourceMappingURL=db.js.map